module.exports = __webpack_public_path__ + "static/media/CommentSmall.63a343e6.svg";